export default __webpack_public_path__ + "static/media/21111.d61e163f.png";